import angular from 'angular';

/* @ngInject */
/**
 * @returns {Function}
 */
function joinFilter() {
	return (/** @type {string[]} */ input, /** @type {string} */ separator) => input.join(separator);
}

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:join
 * @function
 * @description
 * # join
 * Creates and returns a new string by concatenating all of the elements in an array,
 * separated by commas or a specified separator string.
 *
 * @example
 *   Usage:
 *   <p>{{ ARRAY | join:SEP }}</p>
 *
 *   <p>{{ ['hello', 'world'] | join:',' }}</p> // returns <p>hello,world</p>
 *
 */
angular.module('app')
	.filter('join', joinFilter);
